import React from 'react';
import {Link} from 'react-router-dom';

const TopicItem = ({podcast}) => (
  <div className="topic-item" style={{marginBottom: '42px'}}>
    <Link to={'/'}>{podcast.title}</Link>
    <div className="video-embed" style={{boxShadow: '0 2px 20px 0 rgba(0, 0, 0, 0.23)', paddingBottom: 0}}>
      <div className="frame-wrapper">
        <div dangerouslySetInnerHTML={{__html: podcast.podcast_url}} />
      </div>
    </div>
  </div>
);

export default TopicItem;


// WEBPACK FOOTER //
// ./src/modules/samplePodcasts/components/SamplePodcastItem.js